import { GetAllClaimPreAuthAllList } from "features/preauthorization/config/preauthorizationApi";
import React, { useEffect } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CancelClaim, GetAllClaimsList } from "../config/cliamApi";
import { toast } from "react-toastify";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import MultiSelect from "components/common/MultiSelect";
import paths from "routes/paths";
import moment from "moment";

const CancelClaimModal = ({
  show,
  setShow,
  row,
  page,
  rowsPerPage,
  setStatusCounts,
  setOpenError,
  body,
  setError,
  setTotal,
  setTotalRows,
}) => {
  const dispatch = useDispatch();
  const { cancelReasonList } = useSelector((state) => state.preauthorization);
  const { claimFilters } = useSelector((state) => state.claim);
  const { watch, setValue, control, handleSubmit, reset } = useForm({
    defaultValues: {
      cancel_reason: null,
    },
  });
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const navigate = useNavigate();

  useEffect(() => {
    if (show && cancelReasonList?.length === 0) {
      dispatch(GetAllClaimPreAuthAllList());
    }
  }, [show, dispatch, cancelReasonList]);

  const requestBody = () => ({
    branch_id:
      claimFilters?.branch?.branch_id ||
      selectedBranch?.branch_id ||
      selectedBranch?.value ||
      "",
    payer_id: claimFilters?.payer?.payer_id || "",
    insurance_company_id: claimFilters?.insurance?.insurance_company_id || "",
    claim_type: claimFilters?.claim_type?.claim_types_id || "",
    claimsub_types_name: claimFilters?.claim_sub_type?.claimsub_types_id || "",
    ref_number: claimFilters?.ref_number || "",
    frm_dte: claimFilters?.start_date
      ? moment(claimFilters?.start_date).format("YYYY-MM-DD")
      : "",
    to_dte: claimFilters?.end_date
      ? moment(claimFilters?.end_date).format("YYYY-MM-DD")
      : "",
    is_communication: claimFilters?.communication || false,
    is_secondresponse: claimFilters?.second_response || false,
    ident_typ: claimFilters?.identity_type?.ident_type_id || "",
    pat_det: claimFilters?.patient || "",
    preauth_sts: claimFilters?.claim_status?.allstatus_code || "",
    start_point: page,
    limit: rowsPerPage,
  });
  const fetchCliamsList = async (body = {}) => {
    try {
      const response = await dispatch(GetAllClaimsList(requestBody)).unwrap();
      const claims = response?.data?.claim_data || [];
      const totals = claims.reduce(
        (acc, claim) => {
          acc.net += parseFloat(claim.netamount) || 0;
          acc.gross += parseFloat(claim.grossamount) || 0;
          acc.vat += parseFloat(claim.vatamnt) || 0;
          acc.submitted += parseFloat(claim.submtamount) || 0;
          acc.deductible += parseFloat(claim.patshreamount) || 0;
          acc.discount += parseFloat(claim.discamnt) || 0;
          acc.approved += parseFloat(claim.apprveamount || 0) || 0;
          return acc;
        },
        {
          net: 0,
          gross: 0,
          vat: 0,
          submitted: 0,
          deductible: 0,
          discount: 0,
          approved: 0,
        }
      );
      const counts = claims.reduce((acc, claim) => {
        const status = claim?.claim_status?.toLowerCase() || "unknown";
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {});

      setTotal(totals);
      setStatusCounts(counts);
      setTotalRows(response?.total_rows || 0);
    } catch (error) {
      toast.error("Something Went Wrong");
    }
  };

  const handleCheckListFilter = async () => {
    const body = requestBody(0, rowsPerPage);
    await dispatch(GetAllClaimsList(body));
  };

  const handleCancel = async (data) => {
    const cancelBody = {
      claimid: row?.claim_nwid || row?.claimfull_id || row?.claim_fullid || "",
      cncl_reason: watch("cancel_reason")?.cnclrsn_code || null,
      claim_type: row?.claim_type,
    };
    // return;
    const response = await dispatch(CancelClaim(cancelBody)).unwrap();

    if (response?.status_code === "200") {
      toast.success(response?.message_en);
      navigate(`${paths.claimsList}`);
      setShow(false);
      reset();
      handleCheckListFilter();
    } else {
      setOpenError(true);
      setError(response);
      reset();
      setShow(false);
    }
  };

  return (
    <Modal show={show} centered dialogClassName="wizard-modal">
      <Form
        onSubmit={(e) => {
          e.stopPropagation(); // Prevent it from bubbling up
          handleSubmit((data) => handleCancel(data))(e); // Still process the local form
        }}
      >
        <Modal.Body>
          <FalconCloseButton
            size="sm"
            className="position-absolute top-0 end-0 me-2 mt-2"
            onClick={() => {
              setShow(false);
              reset();
            }}
          />
          <Flex direction="column" alignItems="center" className="mb-3">
            <h6 className="fs-9 text-700">Cancel Operation</h6>
            <h6 className="fs-11 text-400 ">
              Please select a reason for cancellation. This helps us improve
              future processes and address any potential concerns proactively.
            </h6>
          </Flex>

          <Col xs={12} className="mx-auto">
            <label className="form-label">
              Cancel Reason <span className="text-danger">*</span>
            </label>
            <Controller
              name="cancel_reason"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={true}
                  isMulti={false}
                  options={cancelReasonList?.map((item) => ({
                    value: item.cnclrsn_code,
                    label: item.cnclrsn_name,
                  }))}
                  value={
                    field.value
                      ? {
                          value: field.value.cnclrsn_code,
                          label: field.value.cnclrsn_name,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "cancel_reason",
                      selected
                        ? {
                            cnclrsn_code: selected.value,
                            cnclrsn_name: selected.label,
                          }
                        : null
                    );
                  }}
                  formatOptionLabel={({ label }) => <div>{label}</div>}
                  getOptionValue={(option) => option.value}
                  placeholder="Choose ..."
                />
              )}
            />
          </Col>

          <hr />
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button variant="danger" size="sm" onClick={() => setShow(false)}>
              Cancel
            </Button>
            <Button variant="success" size="sm" type="submit">
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
};

export default CancelClaimModal;
